var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHappyEmoticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.98,
    height: 95.158,
    viewBox: "0 0 97.98 95.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_153",
    x: 0,
    y: 0,
    width: 97.98,
    height: 95.158,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoticon",
    transform: "translate(-437.011 -307.421)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 437.01, 307.42)",
    filter: "url(#Path_153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153-2",
    "data-name": "Path 153",
    d: "M503.228,595.633H423.282v77.158h79.98Z",
    transform: "translate(-414.28 -589.63)",
    fill: "#006ab3"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 5.989,
    cy: 5.989,
    r: 5.989,
    transform: "translate(466.642 333.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M441.874,620.715a6.829,6.829,0,1,1,6.831-6.829A6.837,6.837,0,0,1,441.874,620.715Zm0-11.976a5.147,5.147,0,1,0,5.148,5.147A5.152,5.152,0,0,0,441.874,608.74Z",
    transform: "translate(30.756 -274.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 5.989,
    cy: 5.989,
    r: 5.989,
    transform: "translate(493.562 333.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M457.874,620.715a6.829,6.829,0,1,1,6.831-6.829A6.837,6.837,0,0,1,457.874,620.715Zm0-11.976a5.147,5.147,0,1,0,5.148,5.147A5.152,5.152,0,0,0,457.874,608.74Z",
    transform: "translate(41.676 -274.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M456.523,642.448a23.573,23.573,0,0,1-23.341-20.558,1.263,1.263,0,0,1,2.505-.32,21,21,0,0,0,41.673,0,1.262,1.262,0,0,1,2.5.32A23.575,23.575,0,0,1,456.523,642.448Z",
    transform: "translate(29.478 -265.263)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHappyEmoticon);
export default __webpack_public_path__ + "static/media/icon-happy-emoticon.e767b119ef2d4e9d8a332d7b2e2fa172.svg";
export { ForwardRef as ReactComponent };